"use client";

import { c as _c } from "react/compiler-runtime";
import type { CampaignPageSection } from "@growwithai/shared";
import SafeImage from "@/components/common/SafeImage";
import { sectionBgStyle, sectionHeadingStyle } from "../section-style";
type GalleryProps = Extract<CampaignPageSection, {
  type: "gallery";
}>;

/** Grid foto kegiatan/fasilitas 2–4 kolom + caption opsional. */
export default function GallerySection(t0) {
  const $ = _c(16);
  const {
    section
  } = t0;
  if (section.images.length === 0) {
    return null;
  }
  const cols = section.images.length <= 2 ? "sm:grid-cols-2" : section.images.length === 3 ? "sm:grid-cols-3" : "sm:grid-cols-2 lg:grid-cols-4";
  let t1;
  if ($[0] !== section.custom_style) {
    t1 = sectionBgStyle(section.custom_style);
    $[0] = section.custom_style;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== section.custom_style || $[3] !== section.heading) {
    t2 = section.heading && <h2 className="text-center text-2xl font-bold tracking-tight text-warm-black md:text-3xl" style={sectionHeadingStyle(section.custom_style)}>{section.heading}</h2>;
    $[2] = section.custom_style;
    $[3] = section.heading;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = `mt-8 grid grid-cols-2 gap-4 ${cols}`;
  let t4;
  if ($[5] !== section.images) {
    t4 = section.images.map(_temp);
    $[5] = section.images;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t5) {
    t6 = <div className="mx-auto max-w-6xl px-5">{t2}{t5}</div>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t1 || $[14] !== t6) {
    t7 = <section className="bg-white py-14 md:py-20" style={t1}>{t6}</section>;
    $[13] = t1;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
function _temp(img, i) {
  return <figure key={i} className="group overflow-hidden rounded-2xl border border-black/[0.06] bg-warm-cream/40"><SafeImage src={img.url} alt={img.caption ?? ""} loading="lazy" className="aspect-[4/3] w-full object-cover transition-transform duration-300 group-hover:scale-[1.03]" />{img.caption && <figcaption className="px-3 py-2 text-center text-xs text-gray-600">{img.caption}</figcaption>}</figure>;
}